import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { IApiError } from '@models/iapi';
import { PersonalManager } from '@models/personal-manager.model';
import {MessengersPopupInstructionComponent} from './messengers-popup-instruction/messengers-popup-instruction.component';
import {catchError, finalize, merge, of, tap} from 'rxjs';
import {filter} from 'rxjs';
import {Unsubscriber} from '../../classes/unsubscriber';
import {PersonalManagerPopupComponent} from "./personal-manager-popup/personal-manager-popup.component";
import {PersonalManagerService} from "../../../components/dashboard/settings/services/personal-manager.service";
import {AlertToastService, AuthService} from "@services";
import {UserTypeService} from "../../../services/user-type.service";

@Component({
  selector: 'app-messengers-popup',
  templateUrl: './messengers-popup.component.html',
  styleUrls: ['./messengers-popup.component.scss'],
})
export class MessengersPopupComponent extends Unsubscriber implements OnInit {
  constructor(private dialog: MatDialog,
              private personalManagerService: PersonalManagerService,
              private authService: AuthService,
              private userService: UserTypeService,
              private alertToastService: AlertToastService,
              public dialogRef: MatDialogRef<MessengersPopupComponent>) {
    super();
  }

  private personalManagerPopupRef: MatDialogRef<PersonalManagerPopupComponent>;
  private messengersInstructionsPopupRef: MatDialogRef<MessengersPopupInstructionComponent>;

  personalManager: PersonalManager;
  isLoyaltyRozniza: boolean = false;
  isLoading: boolean = false;
  personalManagerErrorTooltip: string = '';

  ngOnInit(): void {
    this.isLoyaltyRozniza = this.userService.isLoyaltyRozniza();

    if (!this.isLoyaltyRozniza) {
      this.loadPersonalManager();
    }

    this.dialogRef.backdropClick().subscribe(() => {
      this.dialog.closeAll();
    });
  }

  private loadPersonalManager(): void {
    const currentRef = this.authService.user.contacts ?
      this.authService.user.contacts[0].CounterpartyRef :
      this.authService.user.contragent.id;

    this.isLoading = true;

    this.personalManagerService.getPersonalManager(currentRef)
      .pipe(
        finalize(() => this.isLoading = false),
        catchError((errors: IApiError[]) => {
          if (errors[0]) {
            this.alertToastService.pushError(errors[0].translatedError);
          }
          this.personalManagerErrorTooltip = 'Сталася помилка отримання даних персонального менеджера';
          return of(null);
        }))
      .subscribe(personalManager => {
        this.isLoading = false;
        this.personalManager = personalManager;
        if (personalManager !== null) {
          this.openPersonalManager();
        }
      });
  }

  openInstruction(): void {
    if (this.messengersInstructionsPopupRef?.componentInstance) {
      this.closePopups();
      return;
    }

    this.closePopups();

    this.messengersInstructionsPopupRef = this.dialog.open(MessengersPopupInstructionComponent, {
      panelClass: 'no-padding',
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      width: '370px',
      backdropClass: 'backdrop-transparent',
      position: {
        bottom: '56px',
        right: '110px',
      },
    });
    const backdrop$ = this.messengersInstructionsPopupRef.backdropClick();
    const link$ = this.messengersInstructionsPopupRef.afterClosed().pipe(filter((v) => v === 'link'));
    this.subscriptions = merge(backdrop$, link$).subscribe(() => {
      this.dialog.closeAll();
    });
  }

  openPersonalManager(): void {
    if (this.isLoading) {
      return;
    }

    if (this.personalManager === null) {
      return;
    }

    if (this.personalManagerPopupRef?.componentInstance) {
      this.closePopups();
      return;
    }

    this.closePopups();

    this.personalManagerPopupRef = this.dialog.open(PersonalManagerPopupComponent, {
      data: {
        personalManager: this.personalManager,
      },
      panelClass: 'no-padding',
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      width: '370px',
      position: {
        bottom: '132px',
        right: '110px',
      },
    });
    this.personalManagerPopupRef.backdropClick().subscribe(() => {
      this.personalManagerPopupRef = null;
      this.dialog.closeAll();
    })
  }

  private closePopups(): void {
    this.personalManagerPopupRef?.close();
    this.messengersInstructionsPopupRef?.close();
  }

  closeAll(): void {
    this.personalManagerPopupRef?.close();
    this.messengersInstructionsPopupRef?.close();
    this.dialogRef.close()
  }
}
